import { createSelector } from '@reduxjs/toolkit';

import { State } from './types';
import { RootState } from '../root-reducer';

const rootSelector = (state: RootState): State => state.SituationsCategory;

export const statusSelector = createSelector(rootSelector, (situationsCategory) => situationsCategory.status);
export const errorSelector = createSelector(rootSelector, (situationsCategory) => situationsCategory.error);
export const situationsCategorySelector = createSelector(rootSelector, (situationsCategory) => situationsCategory.data);

export default {
  statusSelector,
  errorSelector,
  situationsCategorySelector,
};
